<template>
  <div class="text-center">
    <h2 class="mb-5" style="color: green">[임시 테스트용 화면]</h2>
    <span class="pl-4">
      반갑습니다, {{ $store.getters.GET_USER_DATA.ssnName }}님!</span
    >
    <v-btn class="ma-2" color="success" @click="invalidateLocation">
      LBS요청
    </v-btn>

    <v-btn
      class="ma-2"
      color="info"
      @click="$store.commit('RESET_STATE_TOKEN')"
    >
      STATE RESET !!
    </v-btn>

    <span>userData</span>
    <v-text-field :value="stringUserData"></v-text-field>
    <span>IS_AUTHENTICATED</span>
    <v-text-field :value="this.$store.getters.IS_AUTHENTICATED"></v-text-field>
    <span>authToken</span>
    <v-text-field :value="this.$store.getters.GET_AUTH_TOKEN"></v-text-field>
    <span>userKey</span>
    <v-text-field :value="this.$store.getters.GET_USER_KEY"></v-text-field>
    <span>sessionToken</span>
    <v-text-field :value="this.$store.getters.GET_SESSION_TOKEN"></v-text-field>

    <v-btn class="ma-2" color="info" @click="errorTest(null)">
      스크립트 에러 테스트
    </v-btn>
    <v-btn class="ma-2" color="info" @click="messageTest()">
      메세지 테스트
    </v-btn>
  </div>
</template>

<script>
import { callApp } from '@/utils/app/callApp.js';

export default {
  data() {
    return {};
  },
  computed: {
    stringUserData() {
      return JSON.stringify(this.$store.getters.GET_USER_DATA);
    },
  },
  methods: {
    mobileAlert() {
      callApp.mobileAlert();
    },
    setSessionContext() {
      callApp.setSessionContext();
    },
    invalidateLocation() {
      alert('alert - LBS요청');
      const scanningTypes = ['beacon', 'gps'];
      callApp.invalidateLocation(scanningTypes);
    },
    errorTest(param) {
      return param.toString().replace(';', ',');
    },
    messageTest() {
      // alert('동작중');
      this.$router.push('/policyConsent');
    },
  },
};
</script>

<style scoped></style>
